export const retryLazyImport = (importFn, retriesLeft = 5, interval = 600) => {
  return new Promise((resolve, reject) => {
    importFn()
      .then(resolve)
      .catch((error) => {
        if (retriesLeft <= 0) {
          const now = Date.now();
          const lastReload = parseInt(sessionStorage.getItem("last_chunk_reload") || "0", 10);
          if (now - lastReload > 8000) {
            sessionStorage.setItem("last_chunk_reload", String(now));
            window.location.reload();
            return;
          }
          reject(error);
          return;
        }
        setTimeout(() => {
          retryLazyImport(importFn, retriesLeft - 1, Math.round(interval * 1.3)).then(resolve, reject);
        }, interval);
      });
  });
};

export const loadHome = () => retryLazyImport(() => import("./Pages/Home"));
export const loadProducts = () => retryLazyImport(() => import("./Pages/Products"));
export const loadProductsDetail = () => retryLazyImport(() => import("./Pages/ProductsDetail"));
export const loadSubscriptions = () => retryLazyImport(() => import("./Pages/Suscriptions"));
export const loadOrders = () => retryLazyImport(() => import("./Pages/Order"));
export const loadProfile = () => retryLazyImport(() => import("./Pages/UserInfo"));